import React from 'react';
import { motion } from 'framer-motion';
import { AGREEXA_APP_URL } from '../lib/links';
import { Video, FileText, MousePointerClick, Map, Download, Printer, ShoppingCart, Bot, Clock } from 'lucide-react';
const contentTypes = [{
  icon: Video,
  label: 'Short Videos',
  desc: 'Quick visual steps',
  colSpan: 'md:col-span-2',
  color: 'text-blue-500',
  bg: 'bg-blue-500/10'
}, {
  icon: FileText,
  label: 'Long Tutorials',
  desc: 'In-depth written guides',
  colSpan: 'md:col-span-1',
  color: 'text-orange-500',
  bg: 'bg-orange-500/10'
}, {
  icon: MousePointerClick,
  label: 'Interactive Guides',
  desc: 'Step-by-step interactive flows',
  colSpan: 'md:col-span-1',
  color: 'text-purple-500',
  bg: 'bg-purple-500/10'
}, {
  icon: Map,
  label: 'Blueprints',
  desc: 'Detailed schematics',
  colSpan: 'md:col-span-1',
  color: 'text-forest-500',
  bg: 'bg-forest-500/10'
}, {
  icon: Download,
  label: 'Downloadable PDFs',
  desc: 'Take plans offline',
  colSpan: 'md:col-span-1',
  color: 'text-red-500',
  bg: 'bg-red-500/10'
}, {
  icon: Printer,
  label: 'Printable Templates',
  desc: '1:1 scale cut templates',
  colSpan: 'md:col-span-1',
  color: 'text-cyan-500',
  bg: 'bg-cyan-500/10'
}, {
  icon: ShoppingCart,
  label: 'Shopping Lists',
  desc: 'Auto-generated material lists',
  colSpan: 'md:col-span-1',
  color: 'text-yellow-500',
  bg: 'bg-yellow-500/10'
}, {
  icon: Bot,
  label: 'AI Assistants',
  desc: 'Context-aware help',
  colSpan: 'md:col-span-1',
  color: 'text-indigo-500',
  bg: 'bg-indigo-500/10'
}, {
  icon: Clock,
  label: 'Project Timelines',
  desc: 'Gantt charts for builds',
  colSpan: 'md:col-span-1',
  color: 'text-pink-500',
  bg: 'bg-pink-500/10'
}];
export function ModernContent() {
  return <section className="py-24 bg-soft dark:bg-navy-900" data-id="element-236">
      <div className="max-w-7xl mx-auto px-6" data-id="element-237">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-238">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 dark:text-white mb-4" data-id="element-239">
            Learn Your Way
          </h2>
          <p className="text-lg text-navy-700 dark:text-gray-400" data-id="element-240">
            Whether you prefer watching quick videos, reading deep-dive
            tutorials, or following interactive 3D blueprints, we have the
            format for you.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-241">
          {contentTypes.map((type, index) => <motion.div key={type.label} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} onClick={() => {
          window.location.href = AGREEXA_APP_URL;
        }} className={`p-6 rounded-2xl glass-card flex flex-col justify-between group cursor-pointer hover:border-orange-500/50 transition-all ${type.colSpan}`} data-id="element-242">
              <div className={`w-12 h-12 rounded-xl ${type.bg} ${type.color} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`} data-id="element-243">
                <type.icon size={24} data-id="element-244" />
              </div>
              <div data-id="element-245">
                <h3 className="text-lg font-bold text-navy-900 dark:text-white mb-1 group-hover:text-orange-500 transition-colors" data-id="element-246">
                  {type.label}
                </h3>
                <p className="text-sm text-navy-700 dark:text-gray-400" data-id="element-247">
                  {type.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}